export default __webpack_public_path__ + "static/media/gw.fe2fc61b.svg";